import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { PhotoPlaceholder } from "../components/PhotoPlaceholder";
import { PlaceholderNote } from "../components/ComingSoon";
import { GALLERY } from "../content/site";

export default function Photos() {
  return (
    <>
      <PageHero eyebrow="Photos" title="TJ, and the community that carries him" testId="photos-hero">
        <p>
          A respectful gallery of family-approved photographs of TJ and of community
          events. Images are added only with the family’s approval.
        </p>
      </PageHero>

      <section aria-labelledby="gallery-heading" className="px-4 pb-20 sm:px-8 lg:px-16">
        <div className="mx-auto max-w-7xl">
          <h2 id="gallery-heading" className="sr-only">Photo gallery</h2>
          <div className="columns-1 gap-6 sm:columns-2 lg:columns-3">
            {GALLERY.map((photo, i) => (
              <Reveal key={i} delay={(i % 3) * 0.07} className="mb-6 break-inside-avoid">
                {photo.src ? (
                  <figure data-testid={`gallery-photo-${i + 1}`}>
                    <img
                      src={photo.src}
                      alt={photo.alt}
                      className="w-full rounded-2xl border border-sage/10 shadow-sm"
                      loading="lazy"
                    />
                    <figcaption className="mt-2 text-sm text-muted-foreground">{photo.caption}</figcaption>
                  </figure>
                ) : (
                  <PhotoPlaceholder
                    alt={photo.alt}
                    caption={photo.caption}
                    ratio="aspect-[4/3]"
                    testId={`gallery-photo-${i + 1}`}
                  />
                )}
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-10 max-w-3xl">
            <PlaceholderNote testId="photos-placeholder-note">
              <strong className="font-semibold text-ink">Awaiting family-approved photographs.</strong>{" "}
              Each frame above holds a space for a photo and the descriptive text that
              will accompany it, so the gallery is ready the moment the family chooses
              what to share.
            </PlaceholderNote>
          </Reveal>
        </div>
      </section>
    </>
  );
}
